import React, { useState } from 'react';
import Configurations from '@hpstellar/pdp/Configurations/Configurations.js';
import Button from '@hpstellar/core/Button/Button.js';
import { MetricsElement } from "react-metrics";

import withPageComponents from '../../../page/components/with-page-components';
import withConfigurations from '../../../product/components/product-configurations';
import ConfigurationDrawer from '../configuration-drawer';

import './cto-color-picker.less';


const getConfigurations = (variants, selectedColor) => {
    return variants.map((v, i) => {
        const { attributes, product } = v;
        const { displayName, value, ctoConfig = {} } = attributes;
        const { images = [] } = product;
        const [firstImage = {}] = images;
        return {
            label: displayName,
            colorHex: value,
            checked: i === 0,
            imageUrl: firstImage.sm,
            value: ctoConfig.color,
            checked: selectedColor ? ctoConfig.color === selectedColor : i === 0
        }
    });
}

const getSelectedVariant = (variants, value) => {
    return variants.find(c => {
        const { attributes = {} } = c;
        const { ctoConfig = {} } = attributes;
        return ctoConfig.color === value;
    }) || variants[0];
}

const onChange = (sku, setCTOConfiguration, variants, isOpen, closeDrawer, trackCustomMetric, configurations) => (value) => {
    const selectedVariant = getSelectedVariant(variants, value)
    selectedVariant && setCTOConfiguration(sku, selectedVariant.attributes.ctoConfig)
    closeDrawer(!isOpen);

    try{
        let label = configurations.find(c => c && c.value === value).label;
        trackCustomMetric('linkClick', {
            event: 'e_linkClick',
            linkPlacement: 'product',
            linkId: `color-picker-${label}`
        });
    }catch(e){}
}



const ctoColorPicker = ({
    product,
    drawerPosition = 'right',
    ctoConfigurations,
    setCTOConfiguration,
    label = 'Selected Color',
    trackCustomMetric
}) => {
    const [isOpen, closeDrawer] = useState(false);
    const { variants } = product
    if (variants && variants.length > 1) {
        const ctoConfig = ctoConfigurations[product.sku] || {};
        const selectedVariant = getSelectedVariant(variants, ctoConfig.color)
        const { attributes } = selectedVariant;
        const configurations = getConfigurations(variants,ctoConfig.color);
        return <div className='cto-color-picker'>
            <Configurations
                label={label}
                content={attributes.displayName}
                colorVariant
                customColor={attributes.value}
                tally={variants.length > 1 ? `${variants.length - 1} more available` : undefined}
                action={
                    <MetricsElement
                        element='span'
                        data-metrics-event='e_linkClick'
                        data-metrics-link-placement='product'
                        data-metrics-link-id={`color-picker-${attributes.value}`}
                    >
                        <Button
                            size={'small'}
                            variation="tertiary"
                            onClick={() => closeDrawer(!isOpen)}
                            >
                            Modify
                        </Button>
                    </MetricsElement>
                }
            />
            <ConfigurationDrawer
                isOpen={isOpen}
                toggleDrawer={() => closeDrawer(!isOpen)}
                configurations={configurations}
                className='cto-color-drawer'
                subheader={`Color (${variants.length})`}
                onChange={onChange(product.sku, setCTOConfiguration, variants, isOpen, closeDrawer, trackCustomMetric, configurations)}
                drawerPosition={drawerPosition}
                />
        </div>;
    }
    return null;
}

export default withConfigurations(withPageComponents(ctoColorPicker, { components: ['product'] }))
